import "core-js/modules/es6.array.some";
import { constantRoutes } from '@/router/index';
var permission = {
  namespaced: true,
  state: {
    projects: [],
    // 子项目列表
    currPermissionKey: '',
    // 当前子项目菜单key
    routers: constantRoutes,
    // 所有路由
    addRouters: [],
    // 菜单栏路由
    allPermissionKey: [],
    allbuttons: []
  },
  mutations: {
    setRouters: function setRouters(state, routers) {
      state.addRouters = routers;
      state.routers = constantRoutes.concat(routers);
    },
    setProjects: function setProjects(state, projects) {
      state.projects = projects;
    },
    setProjectsAllRouters: function setProjectsAllRouters(state, data) {
      // 设置子项目所有包含的路由地址
      if (data.permissionKey) {
        state.projects.some(function (item) {
          if (item.permissionKey === data.permissionKey) {
            if (item.routes) {
              item.routes.push(data.path);
            } else {
              item.routes = [data.path];
            }
            return true;
          }
        });
      }
    },
    currPermissionKey: function currPermissionKey(state, _currPermissionKey) {
      state.currPermissionKey = _currPermissionKey;
    },
    allPermissionKey: function allPermissionKey(state, _allPermissionKey) {
      state.allPermissionKey = _allPermissionKey;
    },
    allbuttons: function allbuttons(state, _allbuttons) {
      state.allbuttons = _allbuttons;
    }
  }
};
export default permission;